var render = function render(){var _vm=this,_c=_vm._self._c;return _c('az-table',{attrs:{"data":_vm.table.data}})
}
var staticRenderFns = []

export { render, staticRenderFns }